import i18n from '@/translations/i18n'
import {toast} from '@utilities/toast'

export const useCopyToClipboard = () => {
    const copyToClipboard = async (text: string) => {
        try {
            if (navigator.clipboard && typeof navigator.clipboard.writeText === 'function') {
                await navigator.clipboard.writeText(text)
                toast.success(i18n.t('commons:copied'))
            } else {
                const textArea = document.createElement('textarea')
                textArea.value = text

                textArea.style.top = '0'
                textArea.style.left = '0'
                textArea.style.position = 'fixed'

                document.body.appendChild(textArea)
                textArea.focus()
                textArea.select()

                document.execCommand('copy')
                toast.success(i18n.t('commons:copied'))

                document.body.removeChild(textArea)
            }
        } catch (err) {
            console.error('Unable to copy to clipboard', err)
        }
    }

    return {copyToClipboard}
}
